import { Menu } from "@mantine/core";
import { ViewDetailMenuItemProps } from "./types";
import { useNavigate } from "react-router-dom";

export function ViewDetailMenuItem(props: ViewDetailMenuItemProps) {
  const { pickupRequest } = props;
  const navigate = useNavigate();

  function handleClick() {
    navigate(`/pickup-requests/${pickupRequest.id}`);
  }

  return <Menu.Item onClick={handleClick}>View Detail</Menu.Item>;
}
